// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1IuJ2","productName":"Table_productName__3Nis6"};